export const cleanLocationString = (location) => {
  if (location && location.trim() !== '') {
    return location.trim();
  }
  return undefined;
};

export const getLocationStringDefault = (city, state, postalCode) => {
  const cleanCity = cleanLocationString(city);
  const cleanState = cleanLocationString(state);
  const cleanZip = cleanLocationString(postalCode);
  let leftSide;
  let rightSide;
  if (cleanCity) {
    leftSide = cleanCity;
  }
  if (cleanState) {
    rightSide = cleanState;
  }
  if (cleanZip) {
    rightSide = `${rightSide} ${cleanZip}`;
  }
  if (leftSide) {
    return `${leftSide}, ${rightSide}`;
  }
  return rightSide;
};

export const getLocationStringAU = (city, state, postalCode) => {
  const cleanCity = cleanLocationString(city);
  const cleanState = cleanLocationString(state);
  const cleanZip = cleanLocationString(postalCode);
  let leftSide;
  let rightSide;
  if (cleanCity) {
    leftSide = cleanCity.toUpperCase();
  }
  if (cleanState) {
    rightSide = cleanState.toUpperCase();
  }
  if (cleanZip) {
    rightSide = `${rightSide} ${cleanZip.toUpperCase()}`;
  }
  if (leftSide) {
    return `${leftSide}, ${rightSide}`;
  }
  return rightSide;
};

export const getLocationStringEU = (city, postalCode) => {
  const cleanCity = cleanLocationString(city);
  const cleanZip = cleanLocationString(postalCode);
  const parts = [];
  if (cleanZip) {
    parts.push(cleanZip);
  }
  if (cleanCity) {
    parts.push(cleanCity);
  }
  return parts.join(', ');
};

export const getLocationStringNZ = (state, postalCode) => {
  const cleanState = cleanLocationString(state);
  const cleanZip = cleanLocationString(postalCode);
  const parts = [];
  if (cleanState) {
    parts.push(cleanState.toUpperCase());
  }
  if (cleanZip) {
    parts.push(cleanZip.toUpperCase());
  }
  return parts.join(' ');
};

export const isEmptyAddress = (address) => {
  const { line1 = '', line2 = '', line3 = '', city = '', state = '', postalCode = '' } = address;

  const cleanLine1 = cleanLocationString(line1);
  const cleanLine2 = cleanLocationString(line2);
  const cleanLine3 = cleanLocationString(line3);
  const cleanCity = cleanLocationString(city);
  const cleanState = cleanLocationString(state);
  const cleanZip = cleanLocationString(postalCode);

  return !cleanLine1 && !cleanLine2 && !cleanLine3 && !cleanCity && !cleanState && !cleanZip;
};

export const emailStringToMultipleEmails = (emailString) => {
  return emailString ? emailString.split(/[\s,]+/).filter(Boolean) : [];
};

export const cleanedMailToEmailString = (emails) => {
  const cleaneEmails = emailStringToMultipleEmails(emails).join(',');
  if (cleaneEmails === '') {
    return undefined;
  }
  return cleaneEmails;
};

export const cleanedEmailString = (emails) => {
  const cleaneEmails = emailStringToMultipleEmails(emails).join(', ');
  if (cleaneEmails === '') {
    return undefined;
  }
  return cleaneEmails;
};
